class AjaxLoad {
  constructor(element) {
    this.element = element;

    // Prefer the server-rendered, locale-aware URL (carries the Fluent locale
    // query param) so the organism hydrates in the same locale as the page.
    // Fall back to the bare id-based endpoint for any stale cached shell.
    const url =
      this.element.dataset.url || 'organism-ajax/' + this.element.dataset.id;

    fetch(url, {
      headers: {
        'Content-Type': 'application/html; charset=utf-8',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error ${response.status}`); // Handle errors appropriately
        }
        return response.text(); // Get the HTML content
      })
      .then(html => {
        this.element.innerHTML = html;
        // Tell the rest of the JS pipeline that this container now has fresh
        // content. main.js listens for `organisms:loaded` and re-runs the
        // organism init scoped to `event.detail.root`.
        this.element.dispatchEvent(
          new CustomEvent('organisms:loaded', {
            bubbles: true,
            detail: { root: this.element },
          })
        );
      })
      .catch(error => {
        console.error('Failed to load organism:', error);
        // this.element.innerHTML = 'Failed to load.';
        this.element.remove();
      });
  }
}

export default AjaxLoad;
